import styled from 'styled-components';

// Address container styles
export const AddressContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 2rem;
  opacity: 0;
  transform: translateY(20px);
  animation: fadeIn 0.5s ease forwards;
  animation-delay: 0.2s;

  p {
    font-family: var(--mainFont);
    color: var(--grey5);
  }

  address {
    font-style: italic;
    color: var(--grey4);
  }
`;

// Contact card styles
export const ContactCard = styled.div`
  border-bottom: 1px solid var(--grey3);
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  transform: translateY(20px);
  animation: fadeIn 0.5s ease forwards;
  animation-delay: ${({ delay }) => delay || '0.4s'};

  .italics {
    font-style: italic;
    color: var(--grey6);
  }

  p {
    margin-block: 0.5rem;
    font-family: var(--mainFont);
    color: var(--grey5);
  }

  a {
    color: var(--orange4);
    text-decoration: none;
  }
`;

// Contact header styles
export const ContactHeader = styled.h3`
  font-family: var(--headerFont);
  color: var(--grey6);
  margin-bottom: 0.5rem;
`;
